// extracted by mini-css-extract-plugin
export default {"toggle-container":"g__toggle-container--WbN2e","toggle-tab":"g__toggle-tab--Q6OGj","toggle-tab-active":"g__toggle-tab-active--DkqAh"};